
export const initMobileAccordion = (navList: HTMLElement | null) => {
  if (!navList) return;

  const menuList = navList.querySelector("ul") || navList;
  processMenuLevel(menuList, 0);
};

const processMenuLevel = (container: Element, level = 0) => {
  const listItems = container.querySelectorAll(":scope > li");

  listItems.forEach((li) => {
    const submenu = li.querySelector(":scope > ul");
    if (!submenu) return;

    if (li.querySelector(".mobile-toggle")) return;

    const clickableElement = li.querySelector(
      ":scope > [data-nav-toggler], :scope > a",
    );
    if (!clickableElement) return;


    setupMobileToggle(li, clickableElement, submenu, level);
  });
};

const setupMobileToggle = (
  li: Element,
  clickableElement: Element,
  submenu: Element,
  level: number,
) => {
  // Hide submenu by default
  submenu.classList.add("hidden");
  submenu.classList.remove("lg:hidden");

  // Create wrapper
  const wrapper = createWrapper();
  clickableElement.parentNode?.insertBefore(wrapper, clickableElement);
  wrapper.appendChild(clickableElement);

  // Create toggle button
  const toggleBtn = createToggleButton();
  wrapper.appendChild(toggleBtn);

  // Add indentation
  submenu.classList.add("pl-6");

  // Add toggle functionality
  toggleBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleToggleClick(toggleBtn, submenu);
  });

  // Process nested levels
  processMenuLevel(submenu, level + 1);
};

const createWrapper = (): HTMLDivElement => {
  const wrapper = document.createElement("div");
  wrapper.className = "flex items-center justify-between";
  return wrapper;
};

const createToggleButton = (): HTMLButtonElement => {
  const toggleBtn = document.createElement("button");
  toggleBtn.className =
    "mobile-toggle p-2 text-primary lg:hidden text-2xl leading-none font-light";
  toggleBtn.setAttribute("aria-expanded", "false");
  toggleBtn.setAttribute("aria-label", "Toggle submenu");
  toggleBtn.textContent = "+";
  return toggleBtn;
};

const handleToggleClick = (toggleBtn: HTMLButtonElement, submenu: Element) => {
  const isOpen = toggleBtn.getAttribute("aria-expanded") === "true";

  if (isOpen) {
    closeSubmenu(toggleBtn, submenu);
    closeNestedSubmenus(submenu);
  } else {
    openSubmenu(toggleBtn, submenu);
  }
};

const closeSubmenu = (toggleBtn: HTMLButtonElement, submenu: Element) => {
  submenu.classList.add("hidden");
  toggleBtn.setAttribute("aria-expanded", "false");
  toggleBtn.textContent = "+";
};

const openSubmenu = (toggleBtn: HTMLButtonElement, submenu: Element) => {
  submenu.classList.remove("hidden");
  toggleBtn.setAttribute("aria-expanded", "true");
  toggleBtn.textContent = "−";
};

const closeNestedSubmenus = (submenu: Element) => {
  submenu.querySelectorAll(".mobile-toggle").forEach((nestedToggle) => {
    const nestedSubmenu = nestedToggle.closest("div")?.nextElementSibling;
    if (nestedSubmenu && nestedSubmenu.tagName === "UL") {
      nestedSubmenu.classList.add("hidden");
      nestedToggle.setAttribute("aria-expanded", "false");
      nestedToggle.textContent = "+";
    }
  });
};

